<template>
  <el-dialog title="查看二维码" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
    <div class="align-center">
      <div class="mb-8">小程序扫码查看推广记录</div>
      <el-image :src="wxImgUrl" lazy />
    </div>
    <span slot="footer">
      <el-button type="primary" @click="handleClose">知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { wechatQrUrl } from "@/utils/common.js"
export default {
  name: 'qrCodeDialog',
  data () {
    return {
      dialogVisible: false,
      wxImgUrl: ''
    }
  },
  methods: {
    show(id) {
      this.wxImgUrl = wechatQrUrl(id)
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.el-image {
  width: 200px;
  height: 200px;
}
</style>
